import { STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { extDBAssetEntriesManager, type ExtDBType, type IExtDBAssetEntry } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const BEST_MATCH = 'bestMatch';
export const BEST_MATCHES = 'bestMatches';

export const actions: ActionTree<IExtDBAssetEntry, unknown> = {
    async [BEST_MATCH](
        context,
        {
            searchTerm,
            companyName,
            provider,
            rejected = [],
            properties
        }: { searchTerm: string; companyName: string; provider: ExtDBType; rejected: number[]; properties?: string }
    ): Promise<IExtDBAssetEntry> {
        const result = await extDBAssetEntriesManager.getMatch(searchTerm, companyName, provider, rejected, { properties });
        if (result !== null) {
            void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        }
        return result;
    },

    async [BEST_MATCHES](
        context,
        {
            searchTerm,
            companyName,
            provider,
            rejected = [],
            properties
        }: { searchTerm: string; companyName: string; provider: ExtDBType; rejected: number[]; properties?: string }
    ): Promise<IExtDBAssetEntry[]> {
        const results = await extDBAssetEntriesManager.getMatches(searchTerm, companyName, provider, rejected, { properties });
        if (results !== null) {
            void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: results });
        }
        return results ?? [];
    }
};
